import Card from "../cards/Card";
import {useFormik} from "formik";
import Input from "../inputs/Input";
import Button from "../Button";
import {BiUser} from "react-icons/bi";
import * as Yup from "yup";
import {calculateOtpTimer, persianToEnglish} from "../../tools/helpers";
import Switch from "react-switch";
import React, {useContext, useState} from "react";
import {CompanyApprovalContext} from "../../tools/contexts/companyApproval/CompanyApprovalContext";
import ChooseAddonType from "./ChooseAddonType";

import OtpComponent from "./OTP";

const ValidationSchema = Yup.object().shape({
    mobile: Yup.string().matches(/^(09|۰۹)[0-9۰-۹]{9}$/, 'شماره موبایل نامعتبر می‌باشد.').required('شماره موبایل الزامیست.'),
    companyId: Yup.string()
        .min(11, 'شناسه ملی شرکت عددی ۱۱ رقمی می باشد.')
        .max(11, 'شناسه ملی شرکت عددی ۱۱ رقمی می باشد.')
        .required('شناسه ملی شرکت را وارد کنید.').test("isNumber", " شناسه ملی شرکت عددی می باشد", (value) => {
            if (!value) {
                return false
            }
            return !isNaN(persianToEnglish(value))
        }),
    nationalId: Yup.string()
        .min(10, 'کد ملی عددی ۱۰ رقمی می باشد.')
        .max(10, 'کد ملی عددی ۱۰ رقمی می باشد.')
        .required('  کد ملی را وارد کنید.').test("isNumber", " کد ملی عددی می باشد", (value) => {
            if (!value) {
                return false
            }
            return !isNaN(persianToEnglish(value))
        }),
});
const InitConfirm = () => {
    const companyApprovalContext = useContext(CompanyApprovalContext);
    const formik = useFormik({
        validationSchema: ValidationSchema,
        initialValues: {
            nationalId: companyApprovalContext.process?.confirmed_data?.NationalId || '',
            mobile: companyApprovalContext.process.is_my_phone_number === null ? companyApprovalContext.process.platform_user : companyApprovalContext.process.confirmed_data.Mobile,
            companyId: companyApprovalContext.process?.confirmed_data?.CompanyId || '',
            imMember: companyApprovalContext.process.is_my_phone_number === null ? true : companyApprovalContext.process.is_my_phone_number,
        },
        validateOnChange: true,
        onSubmit: (values) => {
            const params = {
                "pid": companyApprovalContext.pid,
                "NationalId": persianToEnglish(values.nationalId),
                "is_user_add_on": addonType === "userAddon",
                "Mobile": persianToEnglish(values.mobile),
                "CompanyId": persianToEnglish(values.companyId),
                "is_my_phone_number": imMember
            }

            companyApprovalContext.handleInitConfirm(params);
        }

    });
    const showChooseAddon = !!companyApprovalContext?.process?.user_add_on_mode;
    const rested = !!companyApprovalContext?.process?.reseted_step;
    const [addonType, setAddonType] = useState("postAddon");
    const [step, setStep] = useState(showChooseAddon ? rested ? "Form" : "ChooseAddon" : "Form");
    const handleChooseAddon = (addonType) => {
        setAddonType(addonType);
        setStep("Form");
    }
    const [imMember, setImMember] = useState((companyApprovalContext.process.is_my_phone_number === null||companyApprovalContext.process.is_my_phone_number===undefined) ? true : companyApprovalContext.process.is_my_phone_number);
    const handleImMember = (value) => {
        setImMember(value);
        if (value) {
            formik.setFieldValue('mobile', companyApprovalContext.process?.platform_user)
        }
        formik.setFieldValue('imMember', value)

    }
    const handleBackToChooseAddon = () => {
        setStep("ChooseAddon")
    }
    if(companyApprovalContext.otpRequired){
        return <div>
            <OtpComponent key={companyApprovalContext.otpTimer} onGenerateOtp={companyApprovalContext.handleRequestOTP}
                          onValidateOtp={companyApprovalContext.handleConfirmOTP}
                          otpLength={5}
                          description={companyApprovalContext.otpDescription}
                          errorMessage={companyApprovalContext.otpError}
                          generateLoading={companyApprovalContext.otpRequestLoading}
                          validateLoading={companyApprovalContext.otpConfirmLoading}
                          timerDuration={companyApprovalContext.otpTimer}
            />
        </div>
    }
    if (step === "ChooseAddon" && companyApprovalContext.process && companyApprovalContext.pid) {
        return <div className="w-11/12 md:w-7/12 lg:w-4/12 mx-auto xl:w-4/12">
            <ChooseAddonType onConfirm={handleChooseAddon} addonType={addonType}/>
        </div>
    }
    return <div className="w-11/12  flex justify-center items-center mx-auto lg:w-5/12 xl:w-4/12  ">
            <Card className={'mt-5 rounded-xl'}>
                <div className="w-full flex justify-center items-center border-b mb-4  flex-col py-3">
                <div className="p-5 rounded-full w-16 h-16 flex justify-center items-center bg-green-50">
                    <BiUser className="text-green-500" size={40}/>
                </div>
                <span className="font-semibold">تکمیل اطلاعات </span>
            </div>
                <form>
                <div className="flex flex-col">
                    <div onClick={() => handleImMember(!imMember)}
                         className="w-full  justify-between  pb-4 border-b mb-2 flex items-center">
                        <span className="text-sm ">عضو هیئت مدیره هستم.</span>
                        <Switch onColor="#36b570" height={20} width={40} uncheckedIcon={false} checkedIcon={false}
                                checked={imMember}
                                onChange={handleImMember}/>
                    </div>
                    <Input value={formik.values.companyId}
                           error={(formik.touched.companyId || formik.errors.companyId) ? formik.errors.companyId : null}
                           placeholder="شناسه ملی شرکت را وارد کنید." name="companyId" type="tel"
                           onChange={formik.handleChange}
                           label={'شناسه ملی شرکت'}/>

                    <Input value={formik.values.nationalId}
                           error={(formik.touched.nationalId || formik.errors.nationalId) ? formik.errors.nationalId : null}
                           placeholder="کد ملی را وارد کنید." name="nationalId" type="tel"
                           onChange={formik.handleChange}
                           label={imMember ? 'کد ملی ' : 'کد ملی عضو هیئت مدیره'}/>
                    {imMember && <div className="w-full" style={{height: "68px"}}/>}
                    {!imMember &&
                        <Input value={formik.values.mobile}
                               error={(formik.touched.mobile || formik.errors.mobile) ? formik.errors.mobile : null}
                               placeholder="شماره موبایل را وارد کنید." name="mobile" type="tel"
                               onChange={formik.handleChange}
                               label={imMember ? 'شماره موبایل ' : 'شماره موبایل عضو هیئت'}/>
                    }
                    <div className={`grid ${rested ? 'grid-cols-1' : 'grid-cols-2'} gap-2 `}>
                        {!rested &&
                            <Button onClick={handleBackToChooseAddon} rounded="rounded-lg" theme="link" type="button"
                                    className="text-sm mt-3  w-full ">بازگشت</Button>
                        }
                        <Button loading={companyApprovalContext.isLoading} onClick={formik.handleSubmit}
                                rounded="rounded-lg" theme="green" type="button"
                                className="text-sm mt-3  w-full ">مرحله بعد</Button>
                    </div>

                </div>
            </form>
            </Card>
           </div>
}
export default InitConfirm;